<template>
  <section>
    <div class="container position-relative text-center">
      <div class="row justify-content-center">
        <article class="col-12 col-sm-8">
          <header>
            <h1 v-if="heading">
              {{ title }} <div class="d-block d-md-none"></div><span v-if="subTitle">{{ subTitle }}</span>
            </h1>
            <h2 v-else>
              {{ title }} <div class="d-block d-md-none"></div><span v-if="subTitle">{{ subTitle }}</span>
            </h2>
          </header>
          <p v-if="paragraph" v-html="paragraph" />
        </article>
      </div>
      <img
        v-if="showImage"
        :src="img"
        class="intro-text__image d-none d-md-block"
      />
    </div>
  </section>
</template>

<script>
export default {
  name: 'ec-page-heading',
  props: {
    heading: {
      type: Boolean,
      default: true
    },
    image: {
      type: Object,
      default () {
        return {
          file: 'be-loyal.png',
          width: '200px',
          height: '156px'
        }
      }
    },
    paragraph: {
      type: String,
      default: ''
    },
    showImage: {
      type: Boolean,
      default: true
    },
    subTitle: {
      type: String,
      default: ''
    },
    title: {
      type: String,
      default: ''
    }
  },
  data () {
    return {}
  },
  computed: {
    img () {
      return require('@/assets/images/' + this.image.file)
    }
  }
}
</script>
